// Category labels used by the Floor Deck machine summary.

export function getMachineCategoryName(machine) {
    return String(machine.description || machine.categoryDescription || machine.category || 'Uncategorized');
}

// Returns [{ name, machines }] in the order categories first appear.
export function groupMachinesByCategory(machines) {
    const groups = new Map();
    (machines || []).forEach((machine) => {
        const name = getMachineCategoryName(machine);
        if (!groups.has(name)) groups.set(name, { name, machines: [] });
        groups.get(name).machines.push(machine);
    });
    return Array.from(groups.values());
}
